var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_23928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 10.1245C10.8051 10.1245 11.8125 9.11715 11.8125 7.87451C11.8125 6.63187 10.8051 5.62451 9.5625 5.62451C8.31986 5.62451 7.3125 6.63187 7.3125 7.87451C7.3125 9.11715 8.31986 10.1245 9.5625 10.1245Z",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.06201H3.9375",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.99951H3.9375",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.937H3.9375",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 11.812C6.58046 11.2881 7.09002 10.8628 7.67582 10.5699C8.26161 10.277 8.90756 10.1245 9.5625 10.1245C10.2174 10.1245 10.8634 10.277 11.4492 10.5699C12.035 10.8628 12.5445 11.2881 12.9375 11.812",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 15.187V2.81201C15.1875 2.50135 14.9357 2.24951 14.625 2.24951L4.5 2.24951C4.18934 2.24951 3.9375 2.50135 3.9375 2.81201V15.187C3.9375 15.4977 4.18934 15.7495 4.5 15.7495H14.625C14.9357 15.7495 15.1875 15.4977 15.1875 15.187Z",
    stroke: "#EBECF0",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_23928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address_book.701fca2ac85b49206e069668f3172f84.svg";
export { ForwardRef as ReactComponent };